/**
 * Created by jonas on 2022-06-29.
 */
import {gsap} from "gsap";

export class TwoLayerText extends PIXI.Container{
    private _topText:PIXI.Text;
    private _bottomText:PIXI.Text;

    constructor(text:string, topStyle:PIXI.TextStyle, bottomStyle?:PIXI.TextStyle) {
        super();
        this._topText = new PIXI.Text(text, topStyle);
        this._topText.anchor.set(0.5,0.5);
        this._topText.alpha = 0;
        if (bottomStyle != undefined){
            this._bottomText = new PIXI.Text(text, bottomStyle);
            this._bottomText.anchor.set(0.5,0.5);

            this.addChild(this._bottomText);
        }
        this.addChild(this._topText);
    }

    public setText(value:string){
        this._topText.text = value;
        if (this._bottomText){
            this._bottomText.text = value;
        }
    }

    public showTop(duration:number = 0.1):gsap.core.Tween {
        return gsap.to(this._topText, {duration:duration, alpha: 1});
    }

    public hideTop(duration:number = 0.1):gsap.core.Tween {
        return gsap.to(this._topText, {duration:duration, alpha: 0});
    }

}